module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Beinwil_(Freiamt)-47ec9f6f9465f739e52fa944a2b11083.svg";